import { useMemo } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import type { ComposerMode } from './ChatComposerBar';

type Props = {
  mode: ComposerMode;
  /** Defaults to true (matches registered chat when pattern is on). */
  enabled?: boolean;
};

/**
 * Diagonal watermark words behind the message list for coded/ghost modes.
 * Render inside IonContent with slot="fixed" (and fixedSlotPlacement="before").
 */
const ChatDiagonalPattern: React.FC<Props> = ({ mode, enabled = true }) => {
  const { t } = useI18n();

  const lines = useMemo(() => {
    const out: string[] = [];
    if (mode === 'coded') out.push(t('chat.pattern.word.secret'));
    if (mode === 'ghost') out.push(t('chat.pattern.word.ghost'));
    return out;
  }, [mode, t]);

  if (!enabled || mode === 'plain' || lines.length === 0) return null;

  const lineContent = (token: string) =>
    Array.from({ length: 20 })
      .map(() => token)
      .join('   ');

  return (
    <div className="chat-diagonal-pattern" slot="fixed" aria-hidden="true">
      <div className="chat-diagonal-pattern-layer">
        {Array.from({ length: 14 }).map((_, idx) => (
          <div key={`pattern-${idx}`} className="chat-diagonal-pattern-line">
            {lineContent(lines[idx % lines.length])}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatDiagonalPattern;

export function chatContentPatternClass(mode: ComposerMode, enabled = true): string {
  if (!enabled || mode === 'plain') return '';
  if (mode !== 'coded' && mode !== 'ghost') return '';
  return 'show-diagonal-pattern';
}
